import script from "./DialogProgramDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogProgramDetail.vue?vue&type=script&setup=true&lang=ts"

import "./DialogProgramDetail.vue?vue&type=style&index=0&id=69070ab0&lang=scss"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QMarkupTable,QBtn,QCardSection,QIcon,QSeparator,QCarousel,QCarouselSlide,QCardActions});
